import { Dialog, Transition } from '@headlessui/react';
import { Dispatch, Fragment, SetStateAction } from 'react';
import cn from 'classnames';
import { warrantyUpsellT } from '@/lib/reebelocare/types';
import SingleDevice from './SingleDevice';
import MultipleDevices from './MultipleDevices';
import settings from '@/settings';

const WarrantyUpsell = ({
  showModal,
  setShowModal,
  warrantyUpsellList,
  setIsCheckingOut,
  isCheckingOut,
  onCheckoutClick,
}: {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  warrantyUpsellList: warrantyUpsellT[];
  setIsCheckingOut: Dispatch<SetStateAction<boolean>>;
  isCheckingOut: boolean;
  onCheckoutClick: () => Promise<void>;
}) => {
  const isUSStore = ['reebelo-dev', 'reebelo-us'].includes(settings.store);

  const onContinue = () => {
    setShowModal(false);
    onCheckoutClick();
  };

  return (
    <Transition show={showModal} as={Fragment}>
      <Dialog
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
        className="relative z-50"
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-700/50" aria-hidden="true" />
        </Transition.Child>
        <div
          className={cn(
            'fixed inset-0 flex max-h-screen w-screen items-center justify-center',
            {
              'p-5': !isUSStore,
              'md:p-5': isUSStore,
            },
          )}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel
              className={cn(
                'relative mx-auto max-h-full w-full overflow-y-auto bg-white md:h-auto md:max-w-[600px]',
                {
                  'h-auto max-w-[600px] rounded-lg': !isUSStore,
                  'h-[100dvh] md:h-auto md:rounded-lg': isUSStore,
                },
              )}
            >
              {warrantyUpsellList.length === 1 ? (
                <SingleDevice
                  onContinue={onContinue}
                  device={warrantyUpsellList[0].device}
                  productWarranty={warrantyUpsellList[0].productWarranty}
                  isCheckingOut={isCheckingOut}
                  setIsCheckingOut={setIsCheckingOut}
                />
              ) : (
                <MultipleDevices
                  onContinue={onContinue}
                  warrantyUpsellList={warrantyUpsellList}
                  isCheckingOut={isCheckingOut}
                  setIsCheckingOut={setIsCheckingOut}
                />
              )}
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default WarrantyUpsell;
